import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './common/dialogDrag.js'
import App from './App'
import './env/env'
import router from './router/index'
import store from './vuex/store'
import Vuex from 'vuex'
import NProgress from 'nprogress'//页面顶部进度条
import 'nprogress/nprogress.css'
import './common/element-variables.scss'
import './common/base.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Print from 'vue-print-nb'
import VueClipboard from 'vue-clipboard2';
import './common/directive.js'
import './common/filterToolbarCollapse.scss'
import './common/resizableAside.scss'
import ResizableAsidePanel from './components/ResizableAsidePanel.vue'
import { installFilterToolbarCollapse, applyFilterToolbarEnhancement } from './common/filterToolbarCollapse.js'

// 引入npm安装的安全版本lodash
import _ from 'lodash'
// 将lodash挂载到全局，覆盖可能存在的不安全版本
window._ = _

Vue.use(ElementUI, { size: 'small' })
Vue.use(Vuex)
Vue.use(VueClipboard)
Vue.use(Viewer, {
	defaultOptions: {
		zIndex: 9999
	}
});
Vue.use(Print);
Vue.component('ResizableAsidePanel', ResizableAsidePanel);
installFilterToolbarCollapse(Vue);
Viewer.setDefaults({
	Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "url" }
});


const redirectWhiteList = ['/login', '/faq']
const publicPages = ['/faq'] // 公开页面，登录和未登录都可以访问

router.beforeEach((to, from, next) => {
	NProgress.start();

	//登陆成功后用户名存入localstore
	var storage = window.sessionStorage;
	var loginName = storage.getItem("loginName");
	var userToken = storage.getItem("userToken");
	
	// 如果是公开页面，直接放行
	if (publicPages.indexOf(to.path) > -1) {
		next();
		return;
	}
	
	if (loginName != null && loginName != "" && userToken != null && userToken != "") {
		if (to.path === '/login') {
			// 已登录用户访问登录页，跳转到首页
			next({
				path: '/home/statistics',
				replace: true
			});
		} else {
			next()
		}
	} else {
		if (redirectWhiteList.indexOf(to.path) > -1) {
			next()
		} else {
			next({
				path: '/login',
				replace: true
			});
		}
	}
})

router.afterEach((to, from) => {
	NProgress.done();
	Vue.nextTick(() => {
		applyFilterToolbarEnhancement(document.getElementById('app'));
	});
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
